import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

export interface WizardActionsBarProps {
  children: ReactNode;
  /** When true, sticky/in-scroll bar instead of the default bottom row in layout flow. */
  inline?: boolean;
}

/**
 * Action row: Back on the left, Continue on the right.
 * Default: bottom row in the wizard layout (sibling below scroll content, like PageContainer).
 * Stays in the React tree so `type="submit"` buttons remain inside their `<form>`.
 */
export function WizardActionsBar({ children, inline }: WizardActionsBarProps) {
  return (
    <div
      className={cn(
        "wizard-page__actions",
        inline && "wizard-page__actions--inline"
      )}
    >
      {children}
    </div>
  );
}
